<template>
  <div class="spo-card rounded bordered p-2 my-3">
    <div class="text-h6 font-weight-bold">Liste des liens générés</div>
    <v-table density="compact" v-if="list_liens_vip.list.length > 0">
      <thead>
        <tr>
          <th class="text-left" style="width: 40px">Détails</th>
          <th class="text-left">Statut</th>

          <th class="text-left">Envoyé à</th>
          <th class="text-left">Valide pour</th>
          <th class="text-left">Utilisation</th>
          <th class="text-left">Action</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="item in list_liens_vip.list" :key="item.id">
          <tr :class="{ 'spo-row-expanded': expandedRow === item.id }" @click="toggleExpand(item.id)"
            class="spo-clickable-row">
            <td class="spo-expand-cell">
              <v-icon :icon="expandedRow === item.id ? 'mdi-chevron-up' : 'mdi-chevron-down'" size="small"></v-icon>
            </td>
            <!-- Statut -->
            <td>
              <v-chip :color="getStatusColor(item)" density="compact" variant="elevated" elevation="0">{{
                getStatusText(item) }}</v-chip>


            </td>

            <!-- Envoyé à -->
            <td @click.stop>
              <div class="d-flex  align-center"><span class="font-weight-bold">{{ item.mail
              }}</span>
                <SportipsButton icon="mdi-send" @click="showResendEmail(item)" v-if="canRensendMail(item)">
                  Renvoyer</SportipsButton>
              </div>
            </td>
            <!-- Valide pour -->
            <td>{{ item.nb_inscrits }} participant<span v-if="item.nb_inscrits > 1">s</span></td>
            <!-- Utilisation -->
            <td>
              <div v-if="item.date_utilisation != '0000-00-00 00:00:00'">Utilisé le {{
                $moment(item.date_utilisation).format("DD/MM/YYYY à HH:mm:ss") }}</div>
            </td>
            <td @click.stop>
              <SportipsButton v-if="item.actif == 1" @onClick="deactivate(item)" class="" icon="mdi-close"
                :loading="loading">Désactiver
              </SportipsButton>
              <SportipsButton v-else @onClick="activate(item)" class="" icon="mdi-check" :loading="loading">
                Ré-activer
              </SportipsButton>
            </td>
          </tr>
          <tr v-if="expandedRow === item.id" class="spo-details-row">
            <td colspan="7" class="pa-3 bg-grey-lighten-4">
              <div class="d-flex flex-column">
                <div>Date d'expiration : <span class="font-weight-bold">{{ getExpirationDate(item) }}</span></div>


                <span class="font-weight-bold text-body-2 d-block mb-1">Parcours</span>
                <div>Le destinataire devra payer l'inscription aux Parcours : <span v-if="item.doit_payer_course == 1"
                    class="font-weight-bold">Oui</span>
                  <span v-else class="font-weight-bold">Non</span>
                </div>
                <div>Le destinataire pourra s'inscrire aux Parcours : <span v-if="item.limit_acces_parcours == 1"
                    class="font-weight-bold">Limité à: {{
                      list_filtered_parcours(item) }}</span>
                  <span v-else class="font-weight-bold">Tous les parcours</span>
                </div>

                <span class="font-weight-bold text-body-2 d-block mb-1">Options</span>
                <div>Le destinataire devra payer l'inscription aux Options : <span v-if="item.doit_payer_option == 1"
                    class="font-weight-bold">Oui</span>
                  <span v-else class="font-weight-bold">Non</span>
                </div>
                <div>Le destinataire pourra s'inscrire aux Options complètes : <span
                    v-if="item.acces_options_completes == 1" class="font-weight-bold">Oui</span>
                  <span v-else class="font-weight-bold">Non</span>
                </div>


                <span class="font-weight-bold text-body-2 d-block mb-1">Activités</span>
                <div>Le destinataire devra payer l'inscription aux Activités : <span
                    v-if="item.doit_payer_activite == 1" class="font-weight-bold">Oui</span>
                  <span v-else class="font-weight-bold">Non</span>
                </div>
                <div>Le destinataire pourra s'inscrire aux Activités complètes : <span
                    v-if="item.acces_activites_completes == 1" class="font-weight-bold">Oui</span>
                  <span v-else class="font-weight-bold">Non</span>
                </div>
                <v-divider class="my-1"></v-divider>
                <div>Lien de l'inscription</div>
                <div>https://sportips.fr/inscription/{{
                  item.for_billetterie == 1 ? "BILLETTERIE_" : "" }}{{ mainStore.module.base }}?code_acces={{ item.token
                  }}</div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </v-table>

    <v-alert v-else variant="tonal" color="info">Aucun lien privilégié pour ce module</v-alert>
    <v-dialog v-model="show_resend_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div>
          </div>
          <div class="text-body-1">Voulez-vous vraiment <b>renvoyer le lien VIP</b> à {{ lien_to_resend.mail }} ?</div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red-darken-4" @click="show_resend_dialog = false">Non</v-btn>
          <v-btn color="green-darken-4" @click="handle_resend_email">Oui</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import List_Liens_VIP from "@/classes/Lien_VIP/List_Liens_VIP.class";
export default {
  data() {
    return {
      list_liens_vip: new List_Liens_VIP(),
      show_resend_dialog: false,
      lien_to_resend: null,
      expandedRow: null,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    getExpirationDate(item) {
      if (item.date_expiration == '0000-00-00') {
        return "Pas de limite, actif jusqu'à la fermeture du module";
      }
      return this.$moment(item.date_expiration).format("DD/MM/YYYY");
    },

    getStatusColor(item) {
      if (item.actif == 0) {
        return "red";
      }
      if (item.date_utilisation != '0000-00-00 00:00:00') {
        return "primary-dark";
      }
      if (item.date_expiration != '0000-00-00' && this.$moment(item.date_expiration).isBefore(this.$moment())) {
        return "primary-dark";
      }

      return "green";

    },
    getStatusText(item) {
      if (item.actif == 0) {
        return "Inactif";
      }
      if (item.date_utilisation != '0000-00-00 00:00:00') {
        return "Utilisé";
      }
      if (item.date_expiration != '0000-00-00' && this.$moment(item.date_expiration).isBefore(this.$moment())) {
        return "Expiré";
      }

      return "Actif";
    },
    toggleExpand(itemId) {
      this.expandedRow = this.expandedRow === itemId ? null : itemId;
    },
    showResendEmail(item) {
      this.show_resend_dialog = true;
      this.lien_to_resend = item;
    },
    canRensendMail(item) {
      const expired = item.date_expiration != "0000-00-00" && this.$moment(item.date_expiration).isBefore(this.$moment());
      return item.actif == "1" && !expired && item.date_utilisation == "0000-00-00 00:00:00" && item.mail != '';
    },
    async handle_resend_email() {

      await this.lien_to_resend.resend_email();
      this.show_resend_dialog = false;

    },
    list_filtered_parcours(item) {
      return item.filter_parcours
        .filter((course) => course.selected)
        .map((course) => course.nom)
        .join(", ");
    },

    async deactivate(lien) {
      await this.list_liens_vip.deactivate(lien.id);
      this.$router.go();
    },
    async activate(lien) {
      await this.list_liens_vip.activate(lien.id);
      this.$router.go();
    },
  },
  async created() {
    this.list_liens_vip.id_module = this.mainStore.module.id;
    await this.list_liens_vip.fetch();
  },
};
</script>

<style lang="scss" scoped>
.spo-clickable-row {
  cursor: pointer;
}

.spo-clickable-row:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
}

.spo-details-row {
  cursor: default;
}
</style>